// import external dependencies
import 'jquery'

// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_general.js'

// import local dependencies
// Routes
import Router from './util/Router'
import common from './routes/common'
import blog from './routes/blog'
import postTypeArchivePressEntry from './routes/postTypeArchivePressEntry'
import productsListPage from './routes/productsListPage'
import singleProduct from './routes/singleProduct'

import { TweenLite, Power0 } from 'gsap'

// Components (that stay between pages)
import SiteMenu from './components/SiteMenu'
import SiteFooter from './components/SiteFooter'
import ScrollTopButton from './components/ScrollTopButton'

// Utilities
import BarbaUtils from './util/barba'
import Helpers from './util/helpers'

import 'block-ui'

require('waypoints/lib/noframework.waypoints.js')
require('jquery-bem-utils')
window.imagesLoaded = require('imagesloaded')

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  blog,
  postTypeArchivePressEntry,
  productsListPage,
  singleProduct,
})

const helpers = new Helpers()

const bindJSL = function (event) {
  event.preventDefault()

  var fnName = $(this).data('fn')
  var fnParams = $(this).data('prm')

  if (typeof fnParams === 'undefined') {
    fnParams = []
  }

  fnParams.push($(this))
  var fn = helpers[fnName]
  if (typeof fn === 'function') {
    fn.apply(null, fnParams)
  }
}

const initApp = function () {
  const siteMenu = new SiteMenu()
  // eslint-disable-next-line
  const siteFooter = new SiteFooter($('.site-footer'), { delay: 0.4 })
  const scrollTop = new ScrollTopButton($('.scroll-top'))

  window.app = typeof window.app !== 'undefined' ? window.app : {}
  window.app.store = { siteMenu, scrollTop }

  // Make items with submenu open the submenu on touch devices.
  window.isTouch = false
  if ('ontouchstart' in window) {
    window.isTouch = true
  }

  $('body').on('click', '.jsl', bindJSL)

  $('body').on('keydown', function (event) {
    if (event.key === 'Escape') {
      helpers.closePressPopup()
    }
  })

  $.blockUI.defaults.message = ''
  $.blockUI.defaults.overlayCSS.backgroundColor = 'transparent'
  $.blockUI.defaults.overlayCSS.cursor = 'default'

  BarbaUtils.init(routes, siteMenu)

  TweenLite.set('body', { autoAlpha: 1 })

  if (window.location.search !== '?rl=1') {
    TweenLite.fromTo($('.logo, .site-menu-toggle'), 0.5, { autoAlpha: 0 }, { autoAlpha: 1, ease: Power0.easeNone })
  }

  // Required for custom forms.
  $('label[for="mailchimp-terms"]').addClass('custom-control custom-checkbox').wrapInner('<span class="custom-control-description"></span>')
  $('label[for="mailchimp-terms"]').prepend('<span class="custom-control-indicator"></span>')
  $('.mailchimp-form__terms input').addClass('custom-control-input').prependTo($('label[for="mailchimp-terms"]'))
}

// Load Events
jQuery(document).ready(() => {
  const delay = (window.location.hostname === 'localhost') ? 1000 : 0
  setTimeout(() => { initApp() }, delay)
})



// WEBPACK FOOTER //
// ./scripts/main.js